import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";

import { ISortBy } from "../../../../types";
import { suspiciousCustomersActions } from "../../../../reducers/suspiciousCustomers";
import { SUSPICIOUS_CUSTOMERS_FILTERS } from "./utils";

import { StyledTable } from "../../../../useGeneralStyles";

import TableHead from "./components/TableHead";
import TableBody from "./components/TableBody";
import usePagination from "../../../../hooks/usePagination";
import {
  ContainerWithLoader,
  PaginationWithLimit,
  FilterAutocomplete,
} from "../../../../components/ui";

import { APIAccounts } from "../../../../api";

const Monitoring = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { page, setPage, limit, setLimit } = usePagination();
  const { isLoading, data, count } = useSelector((state) => state.suspiciousCustomers);

  const [sortBy, setSortBy] = useState<ISortBy>({
    by: "id",
    order: false,
  });
  const [search, setSearch] = useState({
    email: "",
  });

  useEffect(() => {
    (async () => {
      try {
        const data = { limit: +limit, page, search, sortBy };
        dispatch(suspiciousCustomersActions.fetchCustomersRequest());
        const email = search?.email
          ?.replaceAll(",", " ")
          .split(" ")
          .filter((email: string) => !!email);

        const response = await APIAccounts.getSuspiciousNotesRequest({
          ...data,
          search: { ...search, email },
        });
        dispatch(suspiciousCustomersActions.fetchCustomersSuccess(response.data));
      } catch (error) {
        console.error("Error fetching suspicious notes", error);
        dispatch(suspiciousCustomersActions.fetchCustomersFailed());
      }
    })();
  }, [page, limit, search, sortBy]);

  const handleSetPage = (value: number) => setPage(value);

  return (
    <div>
      <Box display="flex" mt="15px" mb="5px">
        <FilterAutocomplete
          setSearch={setSearch}
          // @ts-ignore
          search={search}
          filters={SUSPICIOUS_CUSTOMERS_FILTERS}
        />
      </Box>

      <div>
        <p style={{ margin: "5px 0" }}>
          Users found:<b>{count}</b>
        </p>
      </div>

      <div>
        <ContainerWithLoader isLoading={isLoading} report={data}>
          <StyledTable>
            <TableHead handleSort={[sortBy, setSortBy]} />
            <TableBody />
          </StyledTable>
        </ContainerWithLoader>
      </div>

      <div>
        <PaginationWithLimit
          count={count}
          limit={limit}
          page={page}
          setPageState={handleSetPage}
          setLimit={setLimit}
        />
      </div>
    </div>
  );
};

export default Monitoring;
